import { useIntl } from "react-intl";

export const makeNotifs = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { formatMessage } = useIntl();

  const errors = {
    fill: formatMessage({ id: "notifications.error.fill" }),
    match: formatMessage({ id: "notifications.error.match" }),
    length: formatMessage({ id: "notifications.error.length" }),
    password: formatMessage({ id: "notifications.error.password" }),
    symbols: formatMessage({
      id: "notifications.error.symbols",
    }),
    duplicate_params: formatMessage({
      id: "notifications.error.duplicate_params",
    }),
    miner_settings__fill: formatMessage({
      id: "notifications.error.miner_settings.fill",
    }),
    miner_settings__miners: formatMessage({
      id: "notifications.error.miner_settings.miners",
    }),
    search_length: formatMessage({ id: "notifications.error.search.length" }),
    add_pool_setting__protocol: formatMessage({
      id: "notifications.error.add_pool_setting.protocol",
    }),
    add_pool_setting__check: formatMessage({
      id: "notifications.error.add_pool_setting.check",
    }),
    add_pool_setting__some_errors: formatMessage({
      id: "notifications.error.add_pool_setting.some_errors",
    }),
    miner_plan__name: formatMessage({
      id: "notifications.error.miner_plan.name",
    }),
    miner_plan__length: formatMessage({
      id: "notifications.error.miner_plan.length",
    }),
    miner_plan__days: formatMessage({
      id: "notifications.error.miner_plan.days",
    }),
    miner_plan__period_default: formatMessage({
      id: "notifications.error.miner_plan.period_default",
    }),
    miner_plan__periods: formatMessage({
      id: "notifications.error.miner_plan.periods",
    }),
    locations__sameId: formatMessage({
      id: "notifications.error.locations.sameId",
    }),
    locations__fill_fields: formatMessage({
      id: "notifications.error.locations.fill_fields",
    }),
    locations__delete_rack: formatMessage({
      id: "notifications.error.locations.more.delete_rack",
    }),
    locations__edit_rack: formatMessage({
      id: "notifications.error.locations.more.edit_rack",
    }),
    locations_select_rack_section: formatMessage({
      id: "notifications.error.locations.more.rack_section",
    }),
    locations__merge: formatMessage({
      id: "notifications.error.locations.more.merge",
    }),
    locations__merge_lower_zero: formatMessage({
      id: "notifications.error.locations.more.merge_lower_zero",
    }),
    locations__rackItem_move: formatMessage({
      id: "notifications.error.location.rackItem.move",
    }),
    locations__unnalocated_unmerge: formatMessage({
      id: "notifications.error.unnalocated.unmerge",
    }),
    manage__profile_delete: formatMessage({
      id: "manage.profile.delete.error",
    }),
  };

  const notifs = {
    errors,
    ok: {
      success: formatMessage({ id: "notifications.success" }),
      check_email: formatMessage({ id: "notifications.check_email" }),
      user_created: formatMessage({ id: "notifications.user_created" }),
      email__verified: formatMessage({ id: "notifications.email.verified" }),
      password__restored: formatMessage({
        id: "notifications.password.restored",
      }),
      copied: formatMessage({ id: "notifications.copied" }),
      sort_saved: formatMessage({ id: "notifications.saved" }),
      sort_cleared: formatMessage({ id: "notifications.cleared" }),
    },
    loading: formatMessage({ id: "notifications.loading" }),
  };

  return notifs;
};
